export function register() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      // Register only. The browser performs its own update check on a sane
      // schedule (~24h or when cache headers expire); calling
      // registration.update() on every page load adds a network round trip
      // for no benefit while the service worker remains a no-op pass-through.
      navigator.serviceWorker.register("/service-worker.js").catch((error) => {
        console.error("SW registration failed:", error);
      });
    });
  }
}
